module.exports = __webpack_public_path__ + "static/media/Kiribati.b7fe0352.png";